import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config || {};
    const skip = ["/auth/login", "/auth/refresh"];
    if (error.response?.status === 401 && !config._retried && !skip.some((p) => (config.url || "").includes(p))) {
      config._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(config);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "エラーが発生しました。もう一度お試しください。";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const r = await api.post("/admin/uploads", form, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data;
}
